module.exports = __webpack_public_path__ + "static/035_Gippsland-cad3d5d9144f0babbec94b1ae8cb9425.png";